import {
  BrowserClient,
  BrowserConfig,
  Plugin,
} from '@amplitude/analytics-types';

type ExecuteFunction = Plugin<BrowserClient, BrowserConfig>['execute'];

/**
 * Replaces dynamic IDs in non-Explore URLs with wildcards so Amplitude
 * groups page views by route pattern instead of individual entity.
 */
export const normalizePlanUrl = (url: string): string =>
  url
    // /plans/manage-plans/:planId/team-member/:teamMemberId
    .replace(
      /(\/plans\/manage-plans\/)[^/?#]+(\/team-member\/)[^/?#]+/g,
      '$1*$2*',
    )
    // /plans/manage-plans/:planId (and sub-routes like /edit, /train-together)
    .replace(/(\/plans\/manage-plans\/)[^/?#]+/g, '$1*')
    // /plans/my-plans/:planId/doc/:docId
    .replace(/(\/plans\/my-plans\/)[^/?#]+(\/doc\/)[^/?#]+/g, '$1*$2*')
    // /plans/my-plans/:planId
    .replace(/(\/plans\/my-plans\/)[^/?#]+/g, '$1*')
    // /plans/manage-quizzes/:quizId
    .replace(/(\/plans\/manage-quizzes\/)[^/?#]+/g, '$1*')
    // /reports/plans/:planId/team-member/:teamMemberId
    .replace(/(\/reports\/plans\/)[^/?#]+(\/team-member\/)[^/?#]+/g, '$1*$2*')
    // /reports/team-members/:teamMemberId/plan/:planId
    .replace(/(\/reports\/team-members\/)[^/?#]+(\/plan\/)[^/?#]+/g, '$1*$2*')
    // /reports/plans/:planId
    .replace(/(\/reports\/plans\/)[^/?#]+/g, '$1*')
    // /reports/team-members/:teamMemberId
    .replace(/(\/reports\/team-members\/)[^/?#]+/g, '$1*')
    // /admin/categories/:categoryId
    .replace(/(\/admin\/categories\/)[^/?#]+/g, '$1*');

const AMPLITUDE_URL_KEYS = [
  '[Amplitude] Page URL',
  '[Amplitude] Page Location',
  '[Amplitude] Page Path',
] as const;

export const addUrlNormalizationPlugin = (): Plugin<
  BrowserClient,
  BrowserConfig
> => {
  const name = 'url-normalization-plugin';
  const type = 'enrichment';

  const execute: ExecuteFunction = async event => {
    const props = event.event_properties as Record<string, unknown> | undefined;
    if (props) {
      for (const key of AMPLITUDE_URL_KEYS) {
        const value = props[key];
        if (typeof value === 'string') {
          props[key] = normalizePlanUrl(value);
        }
      }
    }
    return event;
  };

  return {
    name,
    type,
    execute,
  };
};
